module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowExtraLight.a32f7d7.woff2";